import { Component, ViewEncapsulation, ChangeDetectionStrategy } from '@angular/core';
import { NG_VALUE_ACCESSOR, NG_VALIDATORS, ValidationErrors, AbstractControl } from '@angular/forms';
import { ControlValueAccessorValidatorBase } from '@fi-app/shared/control-value-accessor-validator-base';
import { isNullOrUndefined } from '@fi-app/shared/utils/is-null-or-undefined';

@Component({
    selector: 'fi-quiz-retakes-settings',
    templateUrl: './quiz-retakes-settings.component.html',
    styleUrl: './quiz-retakes-settings.component.scss',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: { class: 'fi-quiz-retakes-settings' },
    standalone: false,
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: FiQuizRetakesSettingsComponent,
            multi: true,
        },
        {
            provide: NG_VALIDATORS,
            useExisting: FiQuizRetakesSettingsComponent,
            multi: true,
        },
    ],
})
export class FiQuizRetakesSettingsComponent extends ControlValueAccessorValidatorBase<boolean> {
    protected readonly AllowRetakesOptions = [
        { value: true, textId: 'quiz.allow_retakes_description' },
        { value: false, textId: 'quiz.allow_retakes_one_time_description' },
    ];

    public doValidate(c: AbstractControl): ValidationErrors {
        return {
            'retakes-settings-required': isNullOrUndefined(this.ngModel),
        };
    }
}
